<template>
	<div class="header">
		<div class="headContent">
			<div class="meau">
				<div class="meau_right">
					<img class="logo" src="../../assets/img/page/logo.png" />

				</div>

				<div class="meau-left">
					<div class="address" @click="showConnect()">
						<span class="fn-12 van-ellipsis" style="max-width: 80px">
							{{ userAddress | longAddress }}
						</span>
					</div>
					<img src="../../assets/img/page/sz-28.png" style="width: 30px" class="m-x-sm" />

					<!-- <img :src="tuImg" style="width: 30px" class="m-x-sm" /> -->
					<!-- <el-select v-model="valueLocale" @change="change" :popper-append-to-body="false">
						<el-option v-for="(item, index) in actions" :key="index" :label="item.text" :value="item.data">
							<div class="centergrid">
								<span>{{ item.text }}</span>
								<span style="width: 30px; margin-top: 5px">
									<img :src="item.img" style="width: 30px; margin-left: 20px" />
								</span>
							</div>
						</el-option>
					</el-select> -->
				</div>
			</div>
		</div>
		<van-dialog v-model="ConnectWalletShow" title="" :show-confirm-button="false" :confirmButtonText="$t('card.a15')">
			<div class="wallet-box">
				<div class="title-wallet">
					<span>Connect to a wallet</span>
					<img src="../../assets/img/close.png" @click="ConnectWalletShow = false" />
				</div>
				<div class="wallet-list">
					<div class="li" @click="linkWalletFun()">
						<span>Metamask</span>
						<img src="../../assets/wallet/metamask.png" />
					</div>
					<div class="li" @click="linkWalletFun()">
						<span>WalletConnect</span>
						<img src="../../assets/wallet/wallet.svg" />
					</div>
				</div>
			</div>
		</van-dialog>

	</div>
</template>
<script>
import Vue from "vue";
import {
	Icon,
	Popover,
	Popup,
	Toast,
	Dialog,
	PullRefresh
} from "vant";
Vue.use(Icon).use(Popover).use(Popup).use(Dialog).use(Toast).use(PullRefresh);
import {
	userApi,
	nodeSubApi
} from "../../request/api.js"; //自己的封装
import {
	mainApiData
} from '@/request/api.js';
import {
	linkWallet
} from "../../../public/static/linkWallet.js";
import Web3 from 'web3';
export default {
	name: "headerCon",
	components: {},
	data() {
		return {


			tuImg: "",
			actions: [{
				text: "中文繁体",
				data: "zh_TW",
				img: require("@/assets/img/header/cn.png"),
			}, {
				text: "中文简体",
				data: "zh_CN",
				img: require("@/assets/img/header/cn.png"),
			}, {
				text: "English",
				data: "en_US",
				img: require("@/assets/img/header/en.png"),
			},
				// {
				//   text: "しろうと",
				//   data: "ja_JP",
				//   // img: require('@/assets/img/header/en.png')
				// },
				// {
				//   text: "한국어",
				//   data: "ko_KR",
				//   // img: require('@/assets/img/header/en.png')
				// },
				// {
				//   text: "русский",
				//   data: "be_BY",
				//   // img: require('@/assets/img/header/en.png')
				// },
				// {
				//   text: "ภาษาไทย",
				//   data: "th_TH",
				//   // img: require('@/assets/img/header/en.png')
				// },
			],
			valueLocale: this.$i18n.locale,
			userAddress: '',
			ConnectWalletShow: false

		};
	},
	created() {
		this.change(this.$i18n.locale);
		this.userAddress = localStorage.getItem('addr');
		this.Init()
	},
	destroyed() {

	},
	filters: {
		longAddress(val) {
			if (val == "chainIdError") {
				return "Connect Wallet";
			}
			if (val) {
				return (val.substring(0, 4) + "..." + val.substring(val.length - 5, val.length));
			} else {
				return "Connect";
			}
		},
	},
	computed: {
		TOKEN: function () {
			return localStorage.getItem("TOKEN");
		},
	},
	watch: {
		"$store.state.userAddress"(newval, oldval) {
			// 判断用户是否拥有节点
			// // this.judgeNode();
			// // 判断用户是否第一次设置登录密码
			// this.isFirstSetLoginPassword();
			// // 判断用户是否绑定谷歌验证
			// this.isSelectGoogle();
		},
		TOKEN(newval, oldval) {
			// // 判断用户是否拥有节点
			// this.judgeNode();
			// // 判断用户是否第一次设置登录密码
			// this.isFirstSetLoginPassword();
			// // 判断用户是否绑定谷歌验证
			// this.isSelectGoogle();
		},
	},
	// existUser
	methods: {
		linkWalletFun() {
			let _this = this;
			// _this.superShowBind = true; ///我加的
			linkWallet((bool, chainId, address) => {
				console.log("chainId:" + chainId);
				if (chainId != 56) {
					this.$store.commit("userAddressChange", "chainIdError");
					return;
				}
				mainApiData.judgeUserAddr().then((res) => {
					if (res.data.data == false) {
						mainApiData.bindUserAddr({ address: address }).then((res) => {
							if (res.data.code == 200) {
								// this.$toast('绑定成功');
								this.Qm();
								this.userAddress = address;
								localStorage.setItem('addr', address)
								this.ConnectWalletShow = false;
							} else {
								this.$toast(res.data.msg);
								this.ConnectWalletShow = false;
							}

						})
					} else {
						mainApiData.getUserAddr().then((resp) => {
							if (resp.data.data == address) {
								const web3 = new Web3(window.ethereum);
								web3.eth.personal.sign('TianYi', address, (err, sign) => {
									if (err != null) {
										//  = false;
										this.linkWalletFun();
									}
									else {
										this.userAddress = address;
										localStorage.setItem('addr', address)
									}

								})
							} else {
								this.$toast('请确保您当前钱包的地址,是您绑定的地址');
							}
						})
					}

				})



				//  localStorage.setItem('addr',address)


				// 查询用户是否绑定

			});
		},
		Init() {
			if (localStorage.getItem('zxy_sign')) {

			} else {
				this.linkWalletFun();

			}
		},
		Qm() {
			linkWallet((bool, chainId, address) => {
				const web3 = new Web3(window.ethereum);
				web3.eth.personal.sign('TianYi', address, (err, sign) => {
					if (err != null) {
				
						this.Qm();
					}
					else {
						this.$toast('绑定成功');
						this.userAddress = address;
						localStorage.setItem('addr', address)
					}

				})
			})
		},

		showConnect() {

			if (localStorage.getItem('addr') != null && localStorage.getItem('addr') != '') {
				return;
			}
			this.ConnectWalletShow = true;
		},
		change(val) {
			this.$i18n.locale = val;
			this.$cookies.set("lang", val);
			this.actions.map((item) => {
				if (item.data == val) {
					this.tuImg = item.img;
				}
			});
		},

	},
};
</script>
<style lang="scss" scoped>
/deep/ .van-toast {
	z-index: 99999999 !important;
}

/deep/ .el-select-dropdown {
	z-index: 9999999 !important;
}

.centergrid {
	display: grid;
	grid-template-columns: 50% 50%;
	justify-content: space-between;
	align-items: center;
}

.header {
	width: 100%;
	height: 55px;
	// background: #0b0b2f;
	z-index: 9999999;
	position: relative;
}

.wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}

/deep/ .van-loading__text {
	color: black;
}

.wallet-box {
	.title-wallet {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 1.2rem;
		padding: 0 0.3rem;
		border-bottom: 0.02rem solid #999;

		span {
			font-size: 0.3rem;
			font-weight: bold;
			color: #333;
		}

		img {
			width: 0.7rem;
			height: 0.7rem;
		}
	}

	.wallet-list {
		padding: 0.5rem 0.3rem;

		.li {
			width: 100%;
			height: 0.8rem;
			background: #edc339;
			border-radius: 1rem;
			margin-top: 0.5rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			box-shadow: 0px 0.03rem 0.06rem rgba(135, 64, 192, 0.2);
			padding: 0 0.3rem;
			background-image: linear-gradient(to right, #ee03ff, #9d8fff);

			span {
				color: #fff;
				font-weight: bold;
				font-size: 0.3rem;
			}

			img {
				width: 0.5rem;
			}
		}

		.li:first-child {
			margin: 0;
		}
	}
}

.left-meau {
	background: #6d3ef7;
	// width: 5.8rem;
	width: (150rem/31.25);
	// border: 1px solid red;
	height: 100vh;
	padding: 0.4rem;
	overflow-y: scroll;
	color: #fff;

	.userinfo-box {
		width: 100%;
		min-height: 2.23rem;
		background: url(../../assets/img/header/user-bg.png) no-repeat;
		background-size: 100% 100%;
		padding-top: 0.3rem;
		padding-left: 0.3rem;
		padding-bottom: 0.26rem;

		.u-1 {
			display: flex;
			align-items: center;
			// border: 1px solid red;
			padding-top: 0.3rem;

			.ft {
				color: 0.38rem;
				font-size: 0.38rem;
				font-weight: bold;
			}

			.vip {
				padding: 0.01rem 0.12rem;
				border-radius: 1rem;
				border: 0.01rem solid #fff;
				font-size: 0.24rem;
				margin-left: 0.19rem;
			}
		}

		.u-2 {
			display: flex;
			justify-content: space-between;
			margin-top: 0.2rem;
			// border: 1px solid red;
			padding-top: 0.1rem;

			.share-link {
				font-size: 0.24rem;
				color: #fff;
			}

			img {
				margin: 0.05rem 0.2rem;
				width: 0.22rem;
				height: 0.22rem;
			}
		}

		.u-3 {
			display: flex;
			justify-content: space-between;
			align-items: center;
			// border: 1px solid red;
			padding-top: 0.1rem;

			.this-type {
				color: #fff;
				font-size: 0.24rem;
			}

			.go-active {
				padding: 0.1rem 0.16rem;
				border-radius: 0.08rem;
				color: #ffec4e;
				font-size: 0.22rem;
				border: 0.02rem solid #ffec4e;
				margin-right: 0.2rem;
			}
		}
	}

	.list-box {
		padding: 0.3rem 0rem;

		.li {
			padding: 0.3rem 0;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.left {
				display: flex;
				align-items: center;

				.img-box {
					width: 0.4rem;
					height: 0.4rem;
					display: flex;
					justify-content: center;
					align-items: center;

					img {
						width: 0.4rem;
					}
				}

				span {
					margin-left: 0.4rem;
					font-size: 0.32rem;
					color: #fff;
					font-weight: bold;
				}
			}

			.right {
				img {
					width: 0.17rem;
					height: 0.3rem;
				}
			}
		}
	}
}

.headContent {
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	// padding: 0 15px;
	// background-image: linear-gradient(to right, #3f1e50, #051f3d);
	z-index: 9999999;
	// background: url("../../assets/img/page/bj.png") no-repeat ;
	background-size: 100% 100%;

	// background-position: center center;
	.meau {
		width: 100%;
		height: 1.11rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		// background: #03080F !important;
		padding-left: 10px;
		padding-top: 15px;

		.meau-left {
			display: flex;
			align-items: center;

			/deep/ .el-input__inner {
				background: transparent;
				width: 84px !important;
				border: 0;
				color: #fff !important;
				padding: 0 !important;
			}

			.vip {
				width: auto;
				padding: 0 0.32rem;
				background: linear-gradient(269deg, #1042b5, #c445ff);
				border-radius: 0.25rem;
				color: #dcb20c;
				font-size: 0.25rem;
				height: 0.43rem;
				line-height: 0.43rem;
			}

			.address {
				padding: 3px 10px;
				background: linear-gradient(269deg, #1042b5, #c445ff);
				border-radius: 10px;
				color: #fff;
				font-size: 12px;
			}
		}

		.meau_right {
			display: flex;
			align-items: center;

			.more {
				width: 0.43rem;
				height: 0.33rem;
			}

			.logo {
				// width: 35px;
				// height: 0.46rem;
				// margin-left: 0.24rem;
			}

			.sign {
				padding: 2px;
				color: #5f88f2;
				border: 0.5px solid #5f88f2;
				border-radius: 3px;
				max-width: 75px;
			}

			.lang-box {
				width: auto;
				padding: 0 0.22rem;
				// background: #fff;
				color: #fff !important;
				border-radius: 0.25rem;
				color: #33244d;
				font-size: 0.25rem;
				height: 0.43rem;
				line-height: 0.43rem;
				margin-left: 0.27rem;
				display: flex;
				align-items: center;

				img {
					width: 0.2rem;
					margin-left: 0.08rem;
					margin-top: 0.03rem;
				}
			}
		}
	}

	.meau_Nav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		white-space: nowrap;

		span {
			font-size: 0.24rem;
			font-weight: 500;
			color: #ffffff;
			padding-bottom: 0.2rem;
			border-bottom: 0.04rem #00000000 solid;
			padding-right: 0.05rem;
		}

		.on {
			border-bottom: 0.04rem #f6a315 solid;
		}
	}
}

/deep/.van-overlay {
	background: rgba(38, 38, 38, 0.2);
	backdrop-filter: blur(10px);
}

.popBox {
	width: 7.5rem;
	height: 8.27rem;
	margin-left: -0.5rem;
	background-image: url(../../assets/img/header/super-bg.png);
	background-repeat: no-repeat;
	background-size: 5.71rem 6.27rem;
	background-position: center center;

	.content {
		width: 5rem;
		height: 7.27rem;
		margin: 0 auto;
		padding-left: 0.5rem;
		background-color: none;
		position: relative;

		.pop_close {
			position: absolute;
			right: 0;
			left: 0;
			margin: 0 auto;
			bottom: -1rem;
			display: flex;
			justify-content: center;

			img {
				width: 0.75rem;
				height: 0.75rem;
				display: block;
				padding-left: 0.5rem;
			}
		}

		.pop_con {
			font-weight: 700;
			text-align: center;
			color: #8f07e7;
			line-height: 0.5rem;
			font-size: 0.26rem;
			padding-top: 3.5rem;

			.my-link-ft {
				font-size: 0.42rem;
				font-weight: bold;
			}

			.my-link {
				padding: 0 0.5rem;
				font-size: 0.26rem;
				margin-top: 0.2rem;
				line-height: 0.3rem;

				textarea {
					width: 100%;
					height: 0.8rem;
					outline: none;
					border-radius: 0.2rem;
					border: 0.02rem solid #89aaff;
					padding: 0.1rem;
					box-sizing: border-box;
				}
			}
		}

		.pop_btn {
			width: 3.19rem;
			height: 0.92rem;
			background-image: url(../../assets/img/header/copy-btn.png);
			background-size: 100% 100%;
			font-size: 0.32rem;
			text-align: center;
			color: #8f07e7;
			line-height: 0.75rem;
			font-weight: bold;
			margin: 0 auto;
			margin-top: 0.7rem;
		}
	}
}

.van-popup {
	background: rgba(0, 0, 0, 0);
}

/deep/.van-popup--top {
	width: 100vw;
}
</style>